import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { Box } from '../../Box/index.js';
import { useTheme } from '../../hooks/useTheme.js';
import { EditorContent } from '../EditorContent/EditorContent.js';
import { EditorProvider } from '../EditorContext/EditorContext.js';
import { EditorControls } from '../EditorControls/EditorControls.js';
import { useEditor } from '../useEditor/useEditor.js';

var Editor = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, sx = _a.sx, _c = _a.debounceDuration, debounceDuration = _c === void 0 ? 500 : _c, editorProps = __rest(_a, ["disabled", "sx", "debounceDuration"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps({ disabled: disabled, sx: sx }, { themeKey: "editor" });
    var _d = useEditor(__assign({ disabled: disabled, debounceDuration: debounceDuration }, editorProps)), editor = _d.editor, rest = __rest(_d, ["editor"]);
    if (!editor)
        return null;
    return (jsx(EditorProvider, __assign({ value: __assign({ editor: editor }, rest) }, { children: jsxs(Box, __assign({}, forwardProps, { children: [jsx(EditorControls, {}), jsx(EditorContent, {})] })) })));
};

export { Editor };
//# sourceMappingURL=Editor.js.map
